import { useNavigate } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { ExpenseRow } from './ExpenseRow';
import { ExpenseCardMobile } from './ExpenseCardMobile';
import { Expense } from '../../../services/supabase/expenses.service';

interface RecentExpensesProps {
  expenses: Expense[];
  tripShortId?: string;
  maxExpenses?: number;
}

export const RecentExpenses: React.FC<RecentExpensesProps> = ({
  expenses,
  tripShortId,
  maxExpenses = 5
}) => {
  const navigate = useNavigate();
  const recentExpenses = expenses.slice(0, maxExpenses);

  const handleViewAll = () => {
    if (tripShortId) {
      navigate(`/trip/${tripShortId}/expenses`);
    }
  };

  if (expenses.length === 0) {
    return null; // Don't show the component if there are no expenses
  }

  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between space-y-0">
        <CardTitle>Recent Expenses</CardTitle>
        {expenses.length > maxExpenses && (
          <Button
            variant="ghost"
            size="sm"
            onClick={handleViewAll}
            className="gap-1"
          >
            View All
            <ArrowRight className="h-4 w-4" />
          </Button>
        )}
      </CardHeader>
      <CardContent className="p-0">
        {/* Mobile View */}
        <div className="md:hidden space-y-3 p-4">
          {recentExpenses.map((expense) => (
            <ExpenseCardMobile
              key={expense.id}
              expense={expense}
              onClick={() => {
                // Could navigate to expense detail or expand
              }}
            />
          ))}
        </div>

        {/* Desktop View */}
        <div className="hidden md:block border rounded-lg overflow-hidden">
          {recentExpenses.map((expense) => (
            <ExpenseRow key={expense.id} expense={expense} />
          ))}
        </div>

        {expenses.length > maxExpenses && (
          <div className="pt-4 text-center">
            <p className="text-xs text-muted-foreground">
              Showing {maxExpenses} of {expenses.length} expenses
            </p>
          </div>
        )}
      </CardContent>
    </Card>
  );
};
